(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["prime-product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('prime-product-share')) {
    customElements.define('prime-product-share', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.triggers = new Set();
        this.section = this.closest('.shopify-section');
        if (!this.section) return;
        const on = (element, event, handler) => element.addEventListener(event, handler, { signal: this.abort.signal });
        const dialog = this.querySelector('dialog');
        const input = this.querySelector('input');
        const status = this.querySelector('[role="status"]');
        const updateLink = () => {
          const url = new URL(this.dataset.url);
          const variant = this.section.querySelector('.product-details form[action*="/cart/add"] [name="id"]')?.value;
          if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
          const text = this.dataset.title + ' ' + url.href;
          input.value = url.href;
          this.querySelector('[data-whatsapp]').href = 'https://wa.me/?text=' + encodeURIComponent(text);
          this.querySelector('[data-facebook]').href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url.href);
          this.querySelector('[data-x]').href = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.dataset.title) + '&url=' + encodeURIComponent(url.href);
          this.querySelector('[data-email]').href = 'mailto:?subject=' + encodeURIComponent(this.dataset.title) + '&body=' + encodeURIComponent(text);
          return url.href;
        };
        const selectLink = () => {
          input.focus();
          input.select();
          status.textContent = this.dataset.manual;
        };
        const openShare = async (event) => {
          event.preventDefault();
          event.stopPropagation();
          const url = updateLink();
          status.textContent = '';
          if (typeof navigator.share === 'function' && matchMedia('(pointer: coarse)').matches) {
            try {
              await navigator.share({ title: this.dataset.title, url });
              return;
            } catch (error) {
              if (error.name === 'AbortError') return;
            }
          }
          if (!dialog.open) dialog.showModal();
        };
        const mount = () => {
          this.triggers.forEach(button => { if (!button.isConnected) this.triggers.delete(button); });
          const wrappers = this.section.querySelectorAll('.product-media .Vtl-WishlistIcon__ProductPageWrapper');
          if (wrappers.length) {
            this.triggers.forEach(button => {
              if (button.classList.contains('prime-share__trigger--fallback')) { button.remove(); this.triggers.delete(button); }
            });
          }
          const hosts = wrappers.length ? wrappers : [this.section.querySelector('.product-media')].filter(Boolean);
          hosts.forEach(host => {
            if (Array.from(this.triggers).some(button => button.parentElement === host)) return;
            const button = this.querySelector('template').content.firstElementChild.cloneNode(true);
            if (!wrappers.length) button.classList.add('prime-share__trigger--fallback');
            on(button, 'click', openShare);
            host.prepend(button);
            this.triggers.add(button);
          });
        };
        mount();
        this.observer = new MutationObserver(() => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(mount);
        });
        this.observer.observe(this.section, { childList: true, subtree: true });
        on(this.querySelector('[data-close]'), 'click', () => dialog.close());
        on(dialog, 'click', event => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        });
        on(this.querySelector('[data-copy]'), 'click', async () => {
          try {
            await navigator.clipboard.writeText(updateLink());
            status.textContent = this.dataset.copied;
          } catch { selectLink(); }
        });
        this.querySelectorAll('.prime-share__networks a').forEach(link => on(link, 'click', updateLink));
        const nativeButton = this.querySelector('[data-native]');
        if (typeof navigator.share === 'function') {
          nativeButton.hidden = false;
          on(nativeButton, 'click', async () => {
            try {
              await navigator.share({ title: this.dataset.title, url: updateLink() });
            } catch (error) {
              if (error.name !== 'AbortError') selectLink();
            }
          });
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.triggers?.forEach(button => button.remove());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
